import styled from '@emotion/styled';

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #e5e7eb;
    padding: 9px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    width: fit-content;
    position: relative;
`;

export const DateInfo = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Amount = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 1.1rem;
    font-weight: 400;
`;

export const EditButton = styled.button`
    margin-left: 1rem;
    transition: opacity 0.2s ease;
    &:hover {
        opacity: 0.8;
    }
`;
